module.exports = __webpack_public_path__ + "static/media/lyre.b0409ce1.svg";